import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import SEO from '../../components/seo/SEO';
import { getArticleSchema, getBreadcrumbSchema } from '../../components/seo/StructuredData';
import Navbar from "../../components/common/Navbar";
import Footer from "../../components/common/Footer";
import Getintouch from "../../components/layout/GetInTouch";
import logo from '../../logo192.png'

function BlogPage() {
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { id } = useParams();
    
    const getStructuredData = () => {
        if (!blog) return null;
        return [
            getArticleSchema(blog),
            getBreadcrumbSchema([
                { name: "Home", url: "https://algoarts.tech/" },
                { name: "Academy", url: "https://algoarts.tech/academy" },
                { name: "Blog", url: "https://algoarts.tech/academy/blog" },
                { name: blog.heading, url: `https://algoarts.tech/academy/blog/${id}` }
            ])
        ];
    };

    useEffect(() => {
        const fetchBlog = async () => {
            try {
                setLoading(true);
                setError(null);
                const response = await fetch(`https://chethakalakshitha.xyz/algoarts/backend/blogs/${id}`);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                setBlog(data);
            } catch (error) {
                console.error('Error fetching blog:', error);
                setError('Failed to load blog post. Please try again later.');
                setBlog(null);
            } finally {
                setLoading(false);
            }
        };
        if (id) {
            fetchBlog();
        } else {
            setLoading(false);
            setError('Invalid blog ID');
        }
    }, [id]);

    if (loading) {
        return (
            <>
                <Navbar />
                <div className="flex justify-center items-center min-h-screen">
                    <p className="text-gray-600">Loading blog post...</p>
                </div>
                <Footer />
            </>
        );
    }

    if (error || !blog) {
        return (
            <>
                <Navbar />
                <div className="flex justify-center items-center min-h-screen">
                    <p className="text-red-600">{error || 'Blog post not found'}</p>
                </div>
                <Footer />
            </>
        );
    }

    return (
        <>
            {blog && (
                <SEO
                    title={blog.heading}
                    description={blog.content?.find(item => item.type === 'paragraph')?.content || blog.heading}
                    keywords={blog.tag || "Algoarts, software development, technology"}
                    url={`https://algoarts.tech/academy/blog/${id}`}
                    type="article"
                    structuredData={getStructuredData()}
                />
            )}
            <Navbar />
            <div className="flex justify-center w-full h-full mt-8">
                <main className="pt-8 pb-16 lg:pt-16 lg:pb-24 bg-white light:bg-gray-900 antialiased">
                    <div className="flex justify-between px-4 mx-auto max-w-screen-xl">
                        <article className="mx-auto w-full max-w-2xl format format-sm sm:format-base lg:format-lg format-blue light:format-invert">
                            <header className="mb-4 lg:mb-6 not-format">
                                <address className="flex items-center mb-6 not-italic">
                                    <img className="mr-4 w-16 h-16 rounded-full" src={logo} alt={blog.author}/>
                                    <div>
                                        <span className="text-xl font-bold text-gray-900 dark:text-black">{blog.author}</span>
                                        <p className="text-base text-gray-500 dark:text-gray-400">{blog.designation}</p>
                                        <p className="text-base text-gray-500 dark:text-gray-400 ">
                                            <time pubdate dateTime={new Date(blog.createdAt).toISOString()} title={new Date(blog.createdAt).toLocaleDateString()}>
                                                {new Date(blog.createdAt).toLocaleDateString()}
                                            </time>
                                        </p>
                                    </div>
                                </address>
                                <h1 className="mb-4 text-3xl font-extrabold leading-tight text-justify text-gray-900 lg:mb-6 lg:text-4xl dark:text-gray600">
                                    {blog.heading}
                                </h1>
                            </header>
                            {blog.content.sort((a, b) => a.order - b.order).map((item, index) => {
                                switch (item.type) {
                                    case 'paragraph':
                                        return <p key={index} className="mb-4 text-justify font-poppins">{item.content}</p>;
                                    case 'heading':
                                        return <h2 key={index} className="text-xl font-bold">{item.content}</h2>;
                                    case 'subheading':
                                        return <h3 key={index} className="text-lg font-semibold">{item.content}</h3>;
                                    case 'image':
                                        return <img key={index} src={item.content} alt={`Content ${index}`} className="my-4" />;
                                    default:
                                        return null;
                                }
                            })}
                            <p className='text-center'>Article End</p>
                        </article>
                    </div>
                </main>
            </div>
            <Getintouch />
            <Footer />
        </>
    );
}

export default BlogPage;
